export default "__VITE_ASSET__Dhz$vfAK__"